import React, { forwardRef } from 'react';
import type { ForwardedRef } from 'react';
import { motion } from 'framer-motion';

import { InfoActionVariant, infoActionVariants, infoActionTransition } from './InfoAction.motion';
import './InfoAction.scss';

// Can consider making `replacement` an array.
// Additionally, could support multiple "types" of actions.
export interface InfoActionProps {
    content: string;
    keyword: string;
    replacement: string;
    onAction(): void;
}

function InfoActionComponent(
    { content, keyword, replacement, onAction }: InfoActionProps,
    ref: ForwardedRef<HTMLButtonElement>,
) {
    const textParts = content.split(replacement);

    const startMarkup = <span>{textParts[0]}</span>;
    const endMarkup = <span>{textParts[1]}</span>;

    const actionMarkup = <span className="InfoAction-Keyword">{keyword}</span>;

    return (
        <motion.button
            ref={ref}
            className="InfoAction"
            variants={infoActionVariants}
            initial={InfoActionVariant.Initial}
            animate={InfoActionVariant.Show}
            exit={InfoActionVariant.Initial}
            transition={infoActionTransition}
            onClick={onAction}
        >
            <div className="InfoAction-Interior">
                {startMarkup}
                {actionMarkup}
                {endMarkup}
            </div>
        </motion.button>
    );
}

export const InfoAction = forwardRef(InfoActionComponent);
